<template>
	<transition>
		<div class="test_page">
			<p @click="name">
				{{key}}
			</p>
			<div>
				<div class="test">
					{{newName}}
				</div>
				<div class="cls">
					<h1>{{test}}</h1>
					<test @testtest="test12"
					      :newtest="test"/>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
import { mapGetters } from "vuex";
import test from "../components/test.vue";

export default {
	data() {
		return {
			key: "test2232",
			test: 1
		};
	},
	components: {
		test
	},
	computed: {
		...mapGetters(["getPlaylists"]),
		newName() {
			return this.key + 12;
		}
	},
	methods: {
		name() {
			console.log(this.getPlaylists);
		},
		test12(payload) {
			this.test = payload;
		}
	}
};
</script>
<style lang="scss" scoped>
.test_page {
	background-color: rgba(238, 238, 200, 0.8);
	box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
	padding: 0.5rem 0.5rem 1rem 0.5rem;
	height: calc(100vh - 5rem);
	overflow: auto;
	position: absolute;
	margin-top: 4rem;
	width: 90%;
	right: 50%;
	transform: translateX(50%);
	flex-direction: column;
	button {
		cursor: pointer;
		background-color: #bbf291;
		border-radius: 0.2rem;
		line-height: 1.8rem;
		border: none;
		outline: none;
		height: 2.5rem;
		padding: 0.2rem 1rem;
		transition: all 0.2s;
		margin: 0.5rem;
		&:hover {
			background-color: #78956b;
			color: white;
			&:active {
				box-shadow: 0 0 1rem #40dfab;
				background-color: #fff;
			}
		}
	}
	p {
		float: right;
		margin: 0.5rem;
		.bold {
			font-weight: bold;
		}
	}
	.container {
		clear: both;
		margin: 0.5rem 0.5rem 0.5rem 50%;
		width: 90%;
		transform: translateX(-50%);
		.wrap_options {
			width: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin: 0.5rem;
			input[type="text"],
			select#genre {
				width: 40rem;
				border-radius: 3px;
				outline: none;
				border: 1px solid #c9c9c9;
				padding-left: 5px;
				&:focus {
					box-shadow: 0 0 5px #69bf8f;
				}
			}
			select#genre {
				padding-left: 2px;
			}
			label {
				width: 10rem;
			}
		}
	}
}
@media (max-width: 620px) {
	.test_page {
		min-height: calc(100vh - 9rem);
		height: auto;
		min-width: 30rem;
		margin-top: 8rem;
	}
}
.test_page-enter-active {
	transition: all 0.5s ease;
}
.test_page-leave-active {
	transition: all 0.5s ease;
}
.test_page-enter,
.test_page-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TestPage.vue